import { deleteRequest, getRequest, postRequest } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import UserActionTypes from '../user/user-types'
import { successFetchAllFavourites } from './favouritesDashboard-actions'
import FavouritesDashboardActionTypes from './favouritesDashboard-types'

function* addingToFavourites({ payload: ids }) {
    try {
        yield postRequest('/user/assets/favorites', { ids })
    } catch (error) {
        yield
    }
}
export function* onAddingAssetToFavourites() {
    yield takeLatest(FavouritesDashboardActionTypes.ADD_ASSET_TO_FAVOURITES, addingToFavourites)
}

export function* removingFromFavourites({ payload: id }) {
    try {
        yield deleteRequest(`/user/assets/favorites/${id}`)
    } catch (error) {
        yield
    }
}

export function* onRemovingAssetFromFavourites() {
    yield takeLatest(FavouritesDashboardActionTypes.REMOVE_ASSET_FROM_FAVOURITES, removingFromFavourites)
}

function* startFetchAllFavourites() {
    try {
        const { data } = yield getRequest(`/user/assets/favorites`)
        yield put(successFetchAllFavourites(data))
    } catch (error) {
        if (!IS_PRODUCTION) {
            console.log('errr fetch favourtis', error)
        }
    }
}

function* removeMultipleAssetsFromFavourites({ payload: ids }) {
    try {
        yield deleteRequest(`/user/assets/favorites?${ids.map(id => `ids=${id}`).join('&')}`)
        yield startFetchAllFavourites()
    } catch (error) {
        if (!IS_PRODUCTION) {
            console.log('errr delete from favourites', error)
        }
    }
}

export function* onRemoveMultipleAssetsFromFavourites() {
    yield takeLatest(FavouritesDashboardActionTypes.REMOVE_MULTIPLE_ASSETS_FROM_FAVOURITES, removeMultipleAssetsFromFavourites)
}

function* onUserSignIn() {
    // yield startFetchAllFavourites()
}

export function* onSignSuccess() {
    yield takeLatest(UserActionTypes.SIGN_IN_SUCCESS, onUserSignIn)
}

export function* favouritesDashboardSagas() {
    yield all([call(onAddingAssetToFavourites), call(onRemovingAssetFromFavourites), call(onSignSuccess), call(onRemoveMultipleAssetsFromFavourites)])
}
